import angular, { IHttpService } from 'angular';
import { v4 as uuidv4 } from 'uuid';

/**
 * Stored-value (gift card) redemptions microservice.
 *
 * NOTE: the dev server proxies `/v1/api/*` to the backend, rewriting
 * `^/v1/api` -> `/v1`, so this URL reaches the backend at
 * `/v1/storedvalue/redemptions`. This service talks to `$http` directly
 * rather than through the ApiService facade. If the backend path/version
 * changes, update SV_REDEMPTIONS_URL.
 */
const SV_REDEMPTIONS_URL = '/v1/api/b2b/storedvalue/redemptions';

export class RedemptionService {
  static $inject = ['$http'];

  api = {
    sv_redemptions: { url: SV_REDEMPTIONS_URL },

    redeem: (props: {
      tenantId: string;
      cardNumber: string;
      amount: string;
      pin: string;
      cartId?: string;
      reservationId?: string;
      orderId?: string;
      idempotencyKey?: string;
    }) => {
      return this.$http({
        method: 'post',
        headers: {
          'x-tenant-id': props.tenantId,
        },
        url: this.api.sv_redemptions.url,
        data: {
          cardNumber: props.cardNumber,
          amount: props.amount,
          pin: props.pin,
          cartId: props.cartId,
          reservationId: props.reservationId,
          orderId: props.orderId,
          idempotencyKey: props.idempotencyKey || uuidv4(),
          saleChannel: 'insideSalesIndividual',
        },
      });
    },

    remove: (props: {
      tenantId: string;
      authorizationId: string;
      cartId?: string;
      reservationId?: string;
      orderId?: string;
    }) => {
      return this.$http({
        method: 'delete',
        headers: {
          'x-tenant-id': props.tenantId,
        },
        url: this.api.sv_redemptions.url,
        params: {
          authorizationId: props.authorizationId,
          cartId: props.cartId,
          reservationId: props.reservationId,
          orderId: props.orderId,
        },
      });
    },
  };

  constructor(private $http: IHttpService) {}
}

export const RedemptionServiceModule = angular
  .module('acme.common.service.redemption', [])
  .service('RedemptionService', RedemptionService).name;
